// aUEC amounts as people type and read them, after Sierra's helpers (plan 2A
// Assumption 14; sierra-panel.html lines 2420–2423). Unlike Sierra's, parsing
// refuses a negative amount rather than reversing the entry's direction.

const SUFFIX: Readonly<Record<string, number>> = { k: 1e3, m: 1e6, b: 1e9 };

/**
 * Reads `1.5m`, `250k`, `2b`, `1,000,000` or `5 aUEC` as whole aUEC, rounded.
 * Returns null for blank, unreadable or negative input.
 */
export function parseAUEC(value: string | number | null | undefined): number | null {
  const text = String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[, _]/g, '')
    .replace(/auec$/, '');
  const match = /^(\d+(?:\.\d*)?|\.\d+)([kmb])?$/.exec(text);
  if (match === null) return null;
  const amount = Math.round(Number(match[1]) * (SUFFIX[match[2] ?? ''] ?? 1));
  return Number.isSafeInteger(amount) ? amount : null;
}

/** `1,250,000 aUEC`. */
export function aUEC(amount: number): string {
  return `${Math.round(amount).toLocaleString('en-US')} aUEC`;
}

/** `1.25M`, `12.5K`, `2B`, or the full number below 10,000, with trailing zeros trimmed. */
export function shortAUEC(amount: number): string {
  const n = Math.round(amount);
  const size = Math.abs(n);
  if (size >= 1e9) return `${(n / 1e9).toFixed(2).replace(/\.?0+$/, '')}B`;
  if (size >= 1e6) return `${(n / 1e6).toFixed(2).replace(/\.?0+$/, '')}M`;
  if (size >= 1e4) return `${(n / 1e3).toFixed(1).replace(/\.0$/, '')}K`;
  return n.toLocaleString('en-US');
}
